module.exports = __webpack_public_path__ + "img/SmartTV_W650D.0fb6848f.png";